<mat-card>
  <mat-card-header>
    <mat-card-title class="mat-card-title-custom">
      <span *ngIf="type == 55 || type == 56">{{'title.multi_sign_result' | translate}}</span>
      <span *ngIf="type == 84 || type == 85">{{'title.cancel_sign_result' | translate}}</span>
      <span *ngIf="type == 86 || type == 87">{{'title.confirm_sign_result' | translate}}</span>
      <span *ngIf="type == 92 || type == 93">{{'title.multi_delete_result' | translate}}</span>
    </mat-card-title>
  </mat-card-header>


  <mat-card-content class="mb-3 mat-card-content-contract-sm">
    <mat-expansion-panel expanded="true" class="mb-3 mt-3">
      <mat-expansion-panel-header>
        <mat-panel-title class="mat-panel-title" style="color: rgba(0,0,0,.87);" *ngIf="type == 55 || type == 56">
          {{ "title.multi_sign_info" | translate }}
        </mat-panel-title>
        <mat-panel-title class="mat-panel-title" style="color: rgba(0,0,0,.87);" *ngIf="type == 86 || type == 87">
          {{ "title.confirm_sign_info" | translate }}
        </mat-panel-title>
        <mat-panel-title class="mat-panel-title" style="color: rgba(0,0,0,.87);" *ngIf="type == 84 || type == 85">
          {{ "title.cancel_sign_info" | translate }}
        </mat-panel-title>
        <mat-panel-title class="mat-panel-title" style="color: rgba(0,0,0,.87);" *ngIf="type == 92 || type == 93">
          {{ "title.multi_delete_info" | translate }}
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="row" #focus tabindex="-1">
        <div class="col-6 col-sm-6 col-lg-2 col-form-label">{{'search_form.time_start_process' |
          translate}}
        </div>
        <div class="col-6 col-sm-6 col-lg-4 col-form-label font-weight-bold">{{content.startHour}},
          {{content.startDate}}</div>

        <div class="col-6 col-sm-6 col-lg-4 col-form-label">{{'search_form.list_multy_sign_flow' |
          translate}}
        </div>
        <div class="col-6 col-sm-6 col-lg-2 col-form-label font-weight-bold">{{content.totalAmount}}</div>

      </div>

      <div class="row">
        <div class="col-6 col-sm-6 col-lg-2 col-form-label">{{'search_form.time_stop_process' |
          translate}}</div>
        <div class="col-6 col-sm-6 col-lg-4 col-form-label font-weight-bold">{{content.endHour}},
          {{content.endDate}}</div>
        <div class="col-6 col-sm-6 col-lg-4 col-form-label">{{'search_form.list_multy_sign_flow_success' |
          translate}}
        </div>
        <div class="col-6 col-sm-6 col-lg-2 col-form-label font-weight-bold">{{content.successAmount}}</div>
      </div>
      <div class="row">
        <div class="col-6 col-sm-6 col-lg-6 col-form-label"></div>
        <div class="col-6 col-sm-6 col-lg-4 col-form-label">{{'search_form.list_multy_sign_flow_error' |
          translate}}
        </div>
        <div class="col-6 col-sm-6 col-lg-2 col-form-label font-weight-bold">{{content.failAmount}}</div>
      </div>
      <div class="row">
        <div class="col-6 col-sm-6 col-lg-6 col-form-label"></div>
        <div class="col-6 col-sm-6 col-lg-4 col-form-label">{{'search_form.list_multy_sign_flow_cancel' |
          translate}}
        </div>
        <div class="col-6 col-sm-6 col-lg-2 col-form-label font-weight-bold">{{content.cancelAmount}}</div>
      </div>

      <!-- <div class="row">
          <div class="col-6 col-sm-6 col-lg-2 col-form-label">{{'form.enterprise_type' | translate}}
          </div>
          <div class="col-6 col-sm-6 col-lg-4 col-form-label font-weight-bold">{{getEnterpriseTypeOptions(type)}}
          </div>
          <div *ngIf="enterprises.enterpriseType != personalId"
              class="col-6 col-sm-6 col-lg-2 col-form-label">
              {{'search_form.status' | translate}}</div>
          <div *ngIf="enterprises.enterpriseType != personalId" [ngSwitch]="enterprises.status"
              class="col-6 col-sm-6 col-lg-4 col-form-label font-weight-bold">
              <span *ngSwitchCase="true">{{'form.active' | translate}}</span>
              <span *ngSwitchCase="false">{{'form.inactive' | translate}}</span>
          </div>
          <div *ngIf="enterprises.enterpriseType == personalId || enterprises.enterpriseType == null"
              class="col-6 col-sm-6 col-lg-2 col-form-label">
              {{'form.birthday' | translate}}</div>
          <div *ngIf="enterprises.enterpriseType == personalId || enterprises.enterpriseType == null"
              class="col-6 col-sm-6 col-lg-4 col-form-label font-weight-bold">{{enterprises.birthday |
              dateformat}}</div>
      </div>

      <div class="row" *ngIf="enterprises.enterpriseType == personalId || enterprises.enterpriseType == null">
          <label class="col-6 col-sm-6 col-lg-2 col-form-label">{{'form.sex' | translate}}</label>
          <div class="col-6 col-sm-6 col-lg-4" [ngSwitch]="enterprises.sex">
              <label *ngSwitchCase="false" class="col-form-label font-weight-bold">{{'form.female' |
                  translate}}</label>
              <label *ngSwitchCase="true" class="col-form-label font-weight-bold">{{'form.male' |
                  translate}}</label>
          </div>
          <label *ngIf="enterprises.enterpriseType == personalId || enterprises.enterpriseType == null"
              class="col-6 col-sm-6 col-lg-2 col-form-label">{{'search_form.status' |
              translate}}</label>
          <div class="col-6 col-sm-6 col-lg-4" [ngSwitch]="enterprises.status"
              *ngIf="enterprises.enterpriseType == personalId || enterprises.enterpriseType == null">
              <label class="col-form-label font-weight-bold" *ngSwitchCase="true">{{'form.active' |
                  translate}}</label>
              <label class="col-form-label font-weight-bold" *ngSwitchCase="false">{{'form.inactive' |
                  translate}}</label>
          </div>
      </div>

      <div class="row">
          <label class="col-6 col-sm-6 col-lg-2 col-form-label">{{'form.type_certification' |
              translate}}</label>
          <div class="col-6 col-sm-6 col-lg-4 col-form-label font-weight-bold">{{enterprises.enterpriseType !=
              personalId ?
              getEnterpriseTypeOptions(certificate) : getEnterpriseTypeOptions(representativeCertificateName)}}
          </div>
          <label class="col-6 col-sm-6 col-lg-2 col-form-label">{{'form.gpkd' | translate}}</label>
          <div class="col-6 col-sm-6 col-lg-4 col-form-label font-weight-bold">{{enterprises.certificateNo}}</div>
      </div>

      <div class="row">
          <label class="col-6 col-sm-6 col-lg-2 col-form-label">{{'form.issued_by' |
              translate}}</label>
          <div class="col-6 col-sm-6 col-lg-4 col-form-label font-weight-bold">{{enterprises.issuedAt}}</div>
          <label class="col-6 col-sm-6 col-lg-2 col-form-label">{{'form.issued_date' |
              translate}}</label>
          <div class="col-6 col-sm-6 col-lg-4 col-form-label font-weight-bold">{{enterprises.issuedDate |
              dateformat}}</div>
      </div>

      <div class="row">
          <label class="col-6 col-sm-6 col-lg-2 col-form-label"
              *ngIf="enterprises.enterpriseType != personalId && enterprises.enterpriseType != null">{{'form.tax_code'
              |
              translate}}</label>
          <div class="col-6 col-sm-6 col-lg-4 col-form-label font-weight-bold"
              *ngIf="enterprises.enterpriseType != personalId && enterprises.enterpriseType != null">
              {{enterprises.taxCode}}</div>
      </div> -->
    </mat-expansion-panel>
    <mat-expansion-panel  expanded="true" class="mb-3 mt-3">
      <mat-expansion-panel-header>
        <mat-panel-title class="mat-panel-title" style="color: rgba(0,0,0,.87);" *ngIf="type == 55 || type == 56">
          {{ "title.multi_sign_list" | translate }}
        </mat-panel-title>
        <mat-panel-title class="mat-panel-title" style="color: rgba(0,0,0,.87);" *ngIf="type == 84 || type == 85">
          {{ "title.cancel_sign_list" | translate }}
        </mat-panel-title>
        <mat-panel-title class="mat-panel-title" style="color: rgba(0,0,0,.87);" *ngIf="type == 86 || type == 87">
          {{ "title.confirm_sign_list" | translate }}
        </mat-panel-title>
        <mat-panel-title class="mat-panel-title" style="color: rgba(0,0,0,.87);" *ngIf="type == 92 || type == 93">
          {{ "title.multi_delete_list" | translate }}
        </mat-panel-title>
      </mat-expansion-panel-header>
      <mat-table [dataSource]="dataSource" class="mt-3">
        <!-- STT -->
        <ng-container matColumnDef="STT">
          <mat-header-cell *matHeaderCellDef
                           class="mat-header-cell-center no-col mat-cell-non-boder-right-bottom">
            {{'enterprise_contract.table_headers.No' | translate}}
          </mat-header-cell>
          <mat-cell *matCellDef="let element, let i = index"
                    class="mat-header-cell-center no-col mat-cell-non-boder-right-bottom"
                    (click)="$event.stopPropagation()">
            {{i + 1}}
          </mat-cell>
        </ng-container>

        <!-- Tên tài liệu Column -->
        <ng-container matColumnDef="contractName">
          <mat-header-cell *matHeaderCellDef style="max-width: 40%" class="mat-cell-non-boder-right-bottom">
            {{'headertable.document_code_name' | translate}}
          </mat-header-cell>
          <mat-cell *matCellDef="let element" style="max-width: 40%"
                    matTooltip="{{element.contractNameCode ? element.contractNameCode : element.name}}"
                    class="mat-cell-non-boder-right-bottom" (click)="$event.stopPropagation()">
                        <span class="fix-width">{{element.contractNameCode ? element.contractNameCode :
                          element.name}}</span>
          </mat-cell>
        </ng-container>

        <!-- result Column -->
        <ng-container matColumnDef="result">
          <mat-header-cell *matHeaderCellDef style="max-width: 15%;" class="mat-cell-non-boder-right-bottom">
            {{'headertable.sign_result_new' | translate}}
          </mat-header-cell>
          <mat-cell *matCellDef="let element" style="max-width: 15%;" (click)="$event.stopPropagation()"
                    class="mat-cell-non-boder-right-bottom">
                        <span class="fix-width text-center"
                              [ngStyle]="renderStatusColor(element.status)">{{renderStatus(element.status)}}</span>
          </mat-cell>
        </ng-container>

        <!-- Người chuyển Column -->
        <ng-container matColumnDef="detail">
          <mat-header-cell *matHeaderCellDef>
            {{'headertable.detail_sign' | translate}}
          </mat-header-cell>
          <mat-cell *matCellDef="let element"
                    (click)="$event.stopPropagation()">
            <span class="fix-width">{{element.errorMessage ? element.errorMessage : ''}}</span>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;" matRipple class="element-row"
                 [cdkDetailRow]="row">
        </mat-row>
      </mat-table>
    </mat-expansion-panel>

  </mat-card-content>
</mat-card>
